export default {
  KPICardContent: {
    borderBottom: '5px solid',
    '&:last-child': {
      paddingBottom: '16px',
    },
  },
  KPICardTitle: {
    color: '#3D3D3D',
    opacity: 0.8,
    fontSize: '1rem',
    fontWeight: '500',
  },
  chartTitle: {
    color: '#3D3D3D',
    fontSize: '1.05rem',
    fontWeight: '500',
  },
  KPICardValue: {
    fontWeight: '600',
  },
  KPIHelpIcon: {
    marginLeft: '5px',
    fontSize: '1.3rem',
  },
  globalMetricsTitle: {
    fontSize: '1.2rem',
    fontWeight: '600',
    color: '#1A5787',
  },
  chartTipMessage: {
    fontStyle: 'italic',
    color: '#3D3D3D',
    opacity: 0.8,
  },
};
